import React from "react";
import { Bar, Line, Pie } from "react-chartjs-2";
import zoom from 'chartjs-plugin-zoom'
import { getBoundingClientRect } from "../../utils/functions";
import InquiryResult from "../Inquiries/InquiryResult";



class InquiryResults extends React.Component {

    state = {
        show: true,
        // questions: [
        //     {
        //         name: 'Question 1',
        //         scores: { 1: 5, 2: 10, 3: 1, 4: 3 }

        //     },
        //     {
        //         name: 'Question 2',
        //         scores: { 1: 5, 2: 10, 3: 1, 4: 3 }

        //     }
        // ]
        questions: [
            {
                name: 'Question 1',
                number: 1,
                scores: { 1: 5, 2: 10, 3: 1, 4: 3 }
                // scores: 2

            },
            {
                name: 'Question 2',
                number: 2,
                scores: { 1: 5, 2: 10, 3: 1, 4: 3 }
                // scores: 3

            }
        ]

    }




    render() {
        return (

            <div className={'thingInfoList h-100 scroll-no-scrollbar '} style={{ background: '#F5F5F5', }}>
                <div className="w-100 p-2 pld-4" >
                    <div className=" flexcb align-items-center mt-2 ">
                        <div className="d-flex align-items-center">
                            <div className="mrd-2 flexcc">
                                <img style={{ borderRadius: '100px' }} src='/assets/images/coverphoto.jpg' width={40} height={40} />
                            </div>
                            <div className="">

                                <p>
                                    title
                                </p>
                                <p style={{ fontSize: 11 }}>@Aliphm</p>
                            </div>
                        </div>
                        <div className=" prd-3">
                            <div>
                                <p style={{ fontSize: 14 }}>created date  : 1 / 2 / 2023</p>
                            </div>
                            <div>
                                <p style={{ fontSize: 14 }}>participation counts : 1</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div style={{ borderBottom: '1px solid #fcfcfc', margin: '0 15px ' }} /> */}

                <div className="w-100 ">
                    <div className="h-100 mx-2 mt-4" style={{ display: 'flex', }}>

                        <div className="w-100 px-2">
                            {this.state.questions.map((data, index) => {
                                return (
                                    <InquiryResult data={data} index={index} item={this.state.questions} />
                                )
                            })}
                        </div>
                    </div>


                </div>
            </div>

        )
    }
}

export default InquiryResults;

